import { createMutation } from 'react-query-kit';

import { createData } from 'services/http/http';
import { queryClient } from 'services/http/queryClient';
import { UserDTO } from 'support/types';
import portalSchema from 'support/types/schema-portal';

import { useCurrentUser } from '../user/user';

type JoinWaitlistResponse = portalSchema.paths['/v1/waitlists/{key}/join']['post']['responses']['204']['content'];
type JoinWaitlistRequest = portalSchema.paths['/v1/waitlists/{key}/join']['post']['parameters']['path'];

export const useJoinWaitlist = createMutation<JoinWaitlistResponse, JoinWaitlistRequest, Error>({
  mutationFn: async (variables) => {
    const { data } = await createData<JoinWaitlistResponse>(`/v1/waitlists/${variables.key}/join`, {});
    return data;
  },
  onSuccess: (_data, variables) => {
    const currentUser = queryClient.getQueryData<UserDTO>(useCurrentUser.getKey());

    if (currentUser) {
      queryClient.setQueryData<UserDTO>(useCurrentUser.getKey(), {
        ...currentUser,
        waitlists: [...(currentUser.waitlists || []), variables.key],
      });
    }

    queryClient.invalidateQueries(useCurrentUser.getKey());
  },
});
